/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelTipoPraticaOperatoreAssegnazioneDTO } from '../model/models';
import { TipoPraticaOperatoreAssegnazioneCreationForm } from '../model/models';
import { TipoPraticaOperatoreAssegnazioneDTO } from '../model/models';
import { TipoPraticaOperatoreCapabilityPatchForm } from '../model/models';
import { TipoPraticaOperatoriBulkReplaceForm } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface AssegnaTipoPraticaOperatoreRequestParams {
    idTipoPratica: string;
    tipoPraticaOperatoreAssegnazioneCreationForm: TipoPraticaOperatoreAssegnazioneCreationForm;
}

export interface ListTipoPraticaOperatoriRequestParams {
    idTipoPratica: string;
    pageable: Pageable;
    gestione?: boolean;
    q?: string;
}

export interface ReplaceBulkTipoPraticaOperatoriRequestParams {
    idTipoPratica: string;
    tipoPraticaOperatoriBulkReplaceForm: TipoPraticaOperatoriBulkReplaceForm;
}

export interface RevocaTipoPraticaOperatoreRequestParams {
    idTipoPratica: string;
    userId: string;
}

export interface UpdateTipoPraticaOperatoreCapabilityRequestParams {
    idTipoPratica: string;
    userId: string;
    tipoPraticaOperatoreCapabilityPatchForm: TipoPraticaOperatoreCapabilityPatchForm;
}


export interface TipoPraticaOperatoriControllerServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Assegna un operatore-pratica al bando
     * 
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/operatori
* @param requestParameters
     */
    assegnaTipoPraticaOperatore(requestParameters: AssegnaTipoPraticaOperatoreRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaOperatoreAssegnazioneDTO>;

    /**
     * Lista paginata degli operatori assegnati al bando (filtri: gestione, q su email)
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/operatori
* @param requestParameters
     */
    listTipoPraticaOperatori(requestParameters: ListTipoPraticaOperatoriRequestParams, extraHttpRequestParams?: any): Observable<PagedModelTipoPraticaOperatoreAssegnazioneDTO>;

    /**
     * Bulk replace atomico delle assegnazioni del bando (optimistic lock del parent)
     * 
     * @endpoint put /api/v1/gestione/tipi-pratica/{idTipoPratica}/operatori
* @param requestParameters
     */
    replaceBulkTipoPraticaOperatori(requestParameters: ReplaceBulkTipoPraticaOperatoriRequestParams, extraHttpRequestParams?: any): Observable<Array<TipoPraticaOperatoreAssegnazioneDTO>>;

    /**
     * Revoca un\&#39;assegnazione (idempotente)
     * 
     * @endpoint delete /api/v1/gestione/tipi-pratica/{idTipoPratica}/operatori/{userId}
* @param requestParameters
     */
    revocaTipoPraticaOperatore(requestParameters: RevocaTipoPraticaOperatoreRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Aggiorna le capability di una singola assegnazione (optimistic lock per riga)
     * 
     * @endpoint patch /api/v1/gestione/tipi-pratica/{idTipoPratica}/operatori/{userId}
* @param requestParameters
     */
    updateTipoPraticaOperatoreCapability(requestParameters: UpdateTipoPraticaOperatoreCapabilityRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaOperatoreAssegnazioneDTO>;

}
